

import axios from '../extensions/axios';

export default {
    LensServices: {
        getOptionTypes: (query) => axios({ url: "/lens/get-options", params: query }),
        getOptionValues: (query) => axios({ url: "/lens/get-values", params: query }),
        getVariant: ()=>axios("/lens/get-variant"),
        sunglassLabel:(query)=>axios({url:"/lens/sunglass", params: query}),
        checkout: (order_number,formData)=>axios.post(`/api/v1/orders/${order_number}/line_items`,formData),saveFrames: (id,formData)=>axios.post(`/api/v1/orders/line_items/${id}/save_frames`,formData),
        savePrescriptionImg: (id, formData)=>axios.post(`/api/v1/orders/line_items/${id}/save_prescription_image`,formData),
        saveHeightCalculationImage: (formData)=>axios.post(`/api/v1/orders/line_items/save_height_calculation_image`,formData),
        orderNext: async(order_number)=>await axios.put(`/api/v1/checkouts/${order_number}/next.json`),
        reset: ()=>axios.get('lens/reset-session'),
        country:()=>axios.get('/api/v1/countries'),
        state: (id)=>axios.get('/api/v1/states?country_id='+id),
        getOrder:(number)=>axios.get(`/api/v1/orders/${number}`),
        measurement: (body,number)=>axios.put(`/api/v1/checkouts/${number}`,{order: body}),
        address: (body,number)=>axios.put(`/api/v1/checkouts/${number}/next.json`,{order: body}),
        orderUpdate: (body,number)=>axios.put(`/api/v1/orders/${number}.json`,{order: body}),
        delivery: (body,number)=> axios.put(`/api/v1/checkouts/${number}`,body),
        payment: (body,number)=> axios.put(`/api/v1/checkouts/${number}`,body),
        confirm: (number,body)=> axios.put(`/api/v1/checkouts/${number}`,body),
        applyPromo:(number,code)=>axios.put(`/api/v1/orders/${number}/apply_coupon_code`,{"coupon_code":code}),
        removePromo:(number,adjustId)=>axios.delete(`/api/v1/orders/${number}/promotions/${adjustId}`),
        edit:(state,number)=>axios.put(`/api/v1/checkouts/${number}.json`,{state:state}),
        fetchPdValue:(body)=>axios.post(`/api/v1/pupillary_distance_calculator`,body),
        saveSegmentHImage:(body)=>axios.post(`/api/v1/order/line_items/save_segment_height_image`,body),
        clearSelected: (id) => axios.get(`/lens/clear-value/${id}`)
        
     },
     FramesServices: {
        getOptionTypes: (query) => axios({ url: "/frames/get-options", params: query }),
        getOptionValues: (query) => axios({ url: "/frames/get-values", params: query }),
        checkout: (order_number,formData)=>axios.post(`/api/v1/orders/${order_number}/line_items`,formData),
        saveFrames: (id,formData)=>axios.post(`/api/v1/orders/line_items/${id}/save_frames`,formData),
        orderNext: (order_number)=>axios.put(`/api/v1/checkouts/${order_number}/next.json`),
        getVariant: ()=>axios("/frames/get-variant"),
        reset: ()=>axios.get('/frames/reset-session'),
        getProductImage: (id) => axios({ url: `/api/v1/products/${id}/images`}),
        savePrescriptionImg: (id, formData)=>axios.post(`/api/v1/orders/line_items/${id}/save_prescription_image`,formData),
     },
     PaymentServices: {
        capture: (query)=>axios.post('/api/v1/paypal/capture-info',query),
        //express: (query)=>axios.post('/api/v1/paypal/express',query)
        express: (query)=>axios.post('/paypal',query)
     },
     
    }